










import { Component, Vue, Prop } from 'vue-property-decorator'
import ColoredBox from '@/components/atoms/ColoredBox.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import StudentDashboardUnderstanding from '@/components/organisms/v2/StudentDashboardUnderstanding.vue'

@Component({
  components: {
    ColoredBox,
    ButtonBase,
    StudentDashboardUnderstanding,
  },
})
export default class TJContents extends Vue {
  @Prop()
  understandingTotal!: {}

  @Prop()
  understandingHistories!: object[]

  private get studentName(): string {
    return Vue.prototype.$cookies.get('dataGdls')?.userNickname || ''
  }
}
